import { primaryColor, secondaryColor } from './colors';

export const cssBaseline = (theme) => ({
    styleOverrides: {
      html: {
        //overflowX:'hidden',
        height: '100%'
      },
      body: {
        margin: 0,
        padding: 0,
        fontFamily: '"Urbanist", "Helvetica", "Arial", sans-serif',
        color: '#575757',
        background: "linear-gradient(to bottom, #E2E7F3, #FFFFFF)",
        //overflowX:'hidden',
        //height: '100%'
      },
      ".text-blue":{color: primaryColor},
      ".text-red":{color: secondaryColor},
      "a":{color: primaryColor},
      ".main-menu":{
        color: primaryColor
      },
      ".homepage":{
        backgroundColor: '#fff', 
        overflow:'hidden',

        ".hero_section-container":{
          [theme.breakpoints.down('md')]:{
            textAlign: 'center'
          },
          ".title":{
            lineHeight: 1.2,
            marginBottom: theme.spacing(2),
            fontSize: '2.2rem',
            [theme.breakpoints.up('md')]:{
              fontSize: '3rem',
            },
            
          },
          ".subtitle":{
            fontSize: '1.5rem',
            lineHeight: 1.2,
            marginBottom: theme.spacing(4), 
            [theme.breakpoints.up('md')]:{
              fontSize: '1.5rem',
            },
          },
          ".MuiButtonBase-root":{}
        },

        ".solutions_section-title":{
          fontWeight: 'bold', 
          marginBottom: theme.spacing(1), 
          color: primaryColor ,
          display: 'flex',
          alignItems: 'center',
          fontSize: '1.4rem', 
          justifyContent: 'center',
          
          [theme.breakpoints.up('md')]:{
            marginBottom: theme.spacing(2),
            fontSize: '1.8rem', 
            justifyContent: 'left',
          },

          ".icon": {
              fontSize: 24,
              height: 40,
              minWidth: 40,
              display: 'flex',
              alignItems: 'center',
              textAlign: 'center',
              justifyContent: 'center',
              border: '2px solid',
              borderRadius: '50%',
              color: primaryColor,
              marginRight: 8,
              [theme.breakpoints.up('md')]:{
                fontSize: 32,
                height: 62,
                minWidth: 62,
              },
              
            },
        },
        ".solutions_section-text":{
          fontSize:'1rem',
          
          [theme.breakpoints.up('md')]:{
            paddingLeft: 70,
            fontSize:'1.4rem',
          },
        },
      },
      ".homepage-section-title":{
        textAlign: 'center',
        marginBottom: 16,
        [theme.breakpoints.up('md')]:{
          marginBottom: 32,
        },
      },
      
      ".about-section":{
        ".MuiTypography-body2":{
          fontSize: '1.1rem',          
        }
      },
      '.absolute-image': {
        
        objectFit: 'contain',
        pointerEvents: 'none',
        //zIndex: -1,

        [theme.breakpoints.down('md')] :{
          width: '80%',          
        },

        [theme.breakpoints.up('md')]: {
          position: 'absolute',
          top: 0,
          right: 0,
          maxWidth: '45%',
        }

      }, 
      ".documentation-page":{
        //backgroundColor: '#f5f7fa', 
        backgroundColor: '#ffffff', 
        width:'100%',
        fontSize: '1.1rem',
        //overflow:'hidden',
        "h1":{
          color: primaryColor,
          fontSize: '2.4rem', 
        },
        "h2":{
          color: primaryColor,
          fontSize: '1.8rem', 
        },
        "h3":{
          color: primaryColor,
          fontSize: '1.4rem',  
          marginBottom: 8,      
        },
        ".container-inner":{
          paddingTop: '60px', 
          paddingBottom: '40px',
        },
        ".sidebar":{
          ".current":{
            ".MuiTypography-root":{
              fontWeight: 'bold'
            }
          },
          ".MuiTypography-root":{
            fontSize: '1rem', 
          }
        }
       /*  "ul":{
          "li":{
            marginBottom: 6
          }
        } */
        
      },
      ".solution-page":{
        backgroundColor: '#f5f7fa', 
        overflow:'hidden',
        paddingTop: '20px',         
        
        ".page-header":{
          ".page-navigation-container":{
            marginBottom: 20,
          },
          ".page-navigation":{
            width: '100%',
            display: 'flex',
            fontSize: '14px',
            "&.next":{
              justifyContent: 'end',
            }
          },
          '.section-title':{
            marginBottom: 0,
            fontSize: '2rem',
            /* [theme.breakpoints.down('md')]:{
              textAlign: 'center'
            }, */
          },
        },
        ".destacado":{
            fontSize: '1.25rem',
            marginBottom: 20,
            color: primaryColor ,
            [theme.breakpoints.up('md')] : {
              marginBottom: 80,
            }           
          },
        ".solution-page-content":{
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'top right',
            backgroundSize: '45%',
            paddingBottom: 100,
            position: 'relative',
            /* [theme.breakpoints.down('md')]:{
              textAlign: 'center'
            }, */
            ".absolute-image":{
              top: '-6%'
            }
        },
        ".page-navigation":{
          textDecoration: 'none',
          display: 'flex',
          alignItems: 'center',
        },
        ".page-content":{
          paddingBottom: 40,
          
          ".swiper-slide":{
            height: 'auto',
            paddingRight: 20,
          },
          
          ".MuiTypography-body1":{
            fontSize: '1.25rem',
            marginBottom: 80,
            color: primaryColor
          },
          ".MuiTypography-body2":{
            fontSize: '1rem',
            marginBottom: 20,
            paddingLeft: 40,
          }
        },
        ".page-subtitle":{
          color: primaryColor,
          marginBottom: 8,
          fontSize: '1.5rem',
          paddingLeft: 40,
          position: 'relative',
          
          ".icon":{
            fontSize: '2rem',
            position:'absolute',
            left:0
          }
        },
        "h3":{
          color: primaryColor,
          marginBottom: 8,
          fontSize: '1.5rem',
          position: 'relative',

          [theme.breakpoints.down('md')]:{
            //justifyContent: 'center',
            alignItems: 'center',
            display: 'flex',           
            
          },
          [theme.breakpoints.up('md')]:{
            paddingLeft: 40,
          },
          
          ".icon":{
            fontSize: '2rem',

            [theme.breakpoints.down('md')]:{
              marginRight: 4,
              
            },
            
            [theme.breakpoints.up('md')]:{
              position:'absolute',
              left:0,
            },
          }
        },
        ".MuiButton-root":{
          //marginLeft: 70,
        }
      },      
      ".swiper-button-next":{
        color: primaryColor,
      },
      ".swiper-button-prev":{
        color: primaryColor,
      },
      
      ".tabs-solutions":{
        width: 'fit-content',
        margin: 'auto',
        
        "& .MuiTab-root":{
          padding: '8px',
          maxWidth: 'none',
          minWidth: 'auto',
          borderBottom: '1px solid',
          [theme.breakpoints.up('md')]: {
            padding: '10px 16px',
          },
          ".icon":{
            fontSize: 24,
            height: 40,
            width: 40,
            display: 'flex',
            alignItems: 'center',
            textAlign: 'center',
            justifyContent: 'center',
            border: '2px solid',
            borderRadius: '50%',
            [theme.breakpoints.up('md')]:{
              fontSize: 32,
              height: 62,
              width: 62,
            },
          },
          "&.Mui-selected":{
            color: secondaryColor,
            ".icon":{
              color: secondaryColor, 
            }
          }            
        },
        ".MuiTabs-indicator":{
          backgroundColor: secondaryColor
        }
      },

      ".link-back":{
        display: "flex", 
        alignItems: "center", 
        marginBottom: "20px",
        ".MuiTypography-root":{
          color: primaryColor,
          cursor: "pointer"
        } 
      },
      ".contact-page":{
        minHeight: "100vh",
        paddingTop: 40 ,
        paddingBottom: 80,
        
        
      },
      ".contact-card":{
        margin: "auto",
        padding: "20px 12px",
        backgroundColor: "#E2E7F3",
        borderRadius: "12px",
        boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
        position: "relative",
        
        [theme.breakpoints.up('md')]:{
          padding: "50px 40px",
          borderRadius: "32px",
        }, 
        ".MuiInputBase-root":{
          marginBottom: 10,
        },
        ".submit-button":{
          marginTop: 20,
          [theme.breakpoints.down('md')]:{
            width: '100%',          
          },
        }
      },
      ".main-box-calendar":{
        border: "2px solid #E0E0E0",
        borderRadius: "32px",
        textAlign: "center",
        padding: "20px 20px",
        backgroundColor: "#FFFFFF",
          ".btn-submit-calendar":{
            padding: '4px 16px',
            fontSize: 14,          
          },
      },
      ".box-calendar":{
        backgroundColor: "#F7F7F7",
        borderRadius: "8px",
        marginBottom: theme.spacing(2),
        paddingBottom: '12px',
        
        ".MuiDateCalendar-root":{
          width: '100%',
        }         
      },
      ".box-schedule":{
        padding: '0 12px',
        
      },
      ".MuiPickersFadeTransitionGroup-root":{
        color: primaryColor,
        fontWeight: 'bold',
        fontSize: 18,       
        
      },
      
      ".card-alliance":{
        width: '100%',
        height: '100%',
        borderRadius: 30,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
      },
      ".page-error":{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        padding: "20px",
        height: "100vh",
      },
      "code":{backgroundColor: '#dfe8ff', padding: '4px 8px', fontSize: '1rem'}
    }
  })